import { useState } from 'react';
import { useWithDiscardChangeNotice } from '../../../../../controllers/form-index/use-with-discard-change-notice';
export const useHandleDropdownOpenChange = onCancelEdit => {
  const [isOpen, setIsOpen] = useState(false);
  const withDiscardChangeNotice = useWithDiscardChangeNotice();
  const handleDropdownOpenChange = attrs => {
    var _attrs$event;
    (_attrs$event = attrs.event) === null || _attrs$event === void 0 ? void 0 : _attrs$event.stopPropagation();
    if (attrs.isOpen) {
      // To open
      withDiscardChangeNotice(() => setIsOpen(attrs.isOpen), () => {
        onCancelEdit();
        setIsOpen(attrs.isOpen);
      });
    } else {
      // To close
      setIsOpen(attrs.isOpen);
    }
  };
  return {
    isOpen,
    handleDropdownOpenChange
  };
};